import { render } from "./PasswordMailComplete.vue?vue&type=template&id=16b141e8&scoped=true"
import script from "./PasswordMailComplete.vue?vue&type=script&lang=js"
export * from "./PasswordMailComplete.vue?vue&type=script&lang=js"

import "./PasswordMailComplete.vue?vue&type=style&index=0&id=16b141e8&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b141e8"]])

export default __exports__